import {GitCommitIcon} from '@primer/octicons-react'
import {Heading, type HeadingProps, Timeline} from '@primer/react'
import {Octicon} from '@primer/react/deprecated'
import {clsx} from 'clsx'
import type {PropsWithChildren} from 'react'

import styles from './TimelineRow.module.css'

export type TimelineRowProps = {
  leadingVisual?: React.ReactElement
  clipTimeline?: 'none' | 'bottom' | 'top'
  className?: string
}

const DefaultLeadingVisual = () => {
  return <Octicon icon={GitCommitIcon} />
}

function TimelineRowComponent({
  children,
  leadingVisual,
  clipTimeline = 'none',
  className,
}: PropsWithChildren<TimelineRowProps>) {
  return (
    <Timeline.Item className={clsx(className, styles.timelineRowItem, clipTimeline !== 'none' && styles[clipTimeline])}>
      <Timeline.Badge className={styles.timelineRowBadge}>{leadingVisual ?? <DefaultLeadingVisual />}</Timeline.Badge>
      <Timeline.Body className="mt-0">{children}</Timeline.Body>
    </Timeline.Item>
  )
}

function TimelineRowHeading({
  title,
  as,
  ...props
}: {title: string; as: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'} & Omit<HeadingProps, 'as'>) {
  return (
    <Heading as={as} className="text-normal f5 py-1" {...props}>
      {title}
    </Heading>
  )
}

export const TimelineRow = Object.assign(TimelineRowComponent, {
  Heading: TimelineRowHeading,
})

try{ DefaultLeadingVisual.displayName ||= 'DefaultLeadingVisual' } catch {}
try{ TimelineRowComponent.displayName ||= 'TimelineRowComponent' } catch {}
try{ TimelineRowHeading.displayName ||= 'TimelineRowHeading' } catch {}
try{ TimelineRow.displayName ||= 'TimelineRow' } catch {}